import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const tonKhoMenu: NavMenu = {
  title: 'Tồn kho',
  items: [
    {
      title: 'Phiếu yêu cầu xuất kho',
      icon: <AritoIcon icon={426} />,
      href: '/ton-kho/phieu-yeu-cau-xuat-kho',
      group: 0
    },
    {
      title: 'Phiếu nhập kho',
      icon: <AritoIcon icon={138} />,
      href: '/ton-kho/phieu-nhap-kho',
      group: 0
    },
    {
      title: 'Phiếu nhập chênh lệch',
      icon: <AritoIcon icon={138} />,
      href: '/ton-kho/phieu-nhap-chenh-lech',
      group: 0
    },
    {
      title: 'Phiếu xuất kho',
      icon: <AritoIcon icon={139} />,
      href: '/ton-kho/phieu-xuat-kho',
      group: 0
    },
    {
      title: 'Phiếu xuất chênh lệch',
      icon: <AritoIcon icon={139} />,
      href: '/ton-kho/phieu-xuat-chenh-lech',
      group: 0
    },
    {
      title: 'Phiếu xuất điều chuyển',
      href: '/ton-kho/phieu-xuat-dieu-chuyen',
      group: 0
    },
    {
      title: 'Phiếu nhập điều chuyển',
      href: '/ton-kho/phieu-nhap-dieu-chuyen',
      group: 0
    },
    {
      title: 'Tính giá hàng tồn kho',
      items: [
        {
          title: 'Tính giá trung bình',
          icon: <AritoIcon icon={167} />,
          href: '/ton-kho/tinh-gia-hang-ton-kho/tinh-gia-trung-binh'
        },
        {
          title: 'Tính giá nhập trước xuất trước',
          icon: <AritoIcon icon={822} />,
          href: '/ton-kho/tinh-gia-hang-ton-kho/tinh-gia-nhap-truoc-xuat-truoc'
        },
        {
          title: 'Tính tồn kho tức thời',
          icon: <AritoIcon icon={166} />,
          href: '/ton-kho/tinh-gia-hang-ton-kho/tinh-ton-kho-tuc-thoi'
        }
      ],
      group: 0
    },
    {
      title: 'Kiểm kê',
      icon: <AritoIcon icon={727} />,
      items: [
        {
          title: 'Báo cáo kiểm kê',
          icon: <AritoIcon icon={727} />,
          href: '/ton-kho/kiem-ke/bao-cao-kiem-ke'
        },
        {
          title: 'Phiếu yêu cầu kiểm kê',
          icon: <AritoIcon icon={550} />,
          href: '/ton-kho/kiem-ke/phieu-yeu-cau-kiem-ke'
        },
        {
          title: 'Cập nhật kiểm kê',
          icon: <AritoIcon icon={547} />,
          href: '/ton-kho/kiem-ke/cap-nhat-kiem-ke'
        },
        {
          title: 'Xử lý chênh lệch kiểm kê',
          icon: <AritoIcon icon={544} />,
          href: '/ton-kho/kiem-ke/xu-ly-chenh-lech-so-lieu-kiem-ke'
        }
      ],
      group: 1
    },
    {
      title: 'Nhập tự động thành phẩm từ hoá đơn',
      icon: <AritoIcon icon={528} />,
      href: '/ton-kho/nhap-tu-dong-thanh-pham-tu-hoa-don',
      group: 1
    },
    {
      title: 'Xuất tự động nguyên vật liệu',
      icon: <AritoIcon icon={714} />,
      href: '/ton-kho/xuat-tu-dong-nguyen-vat-lieu',
      group: 1
    },
    {
      title: 'Báo cáo tồn kho',
      icon: <AritoIcon icon={152} />,
      items: [
        {
          title: 'Báo cáo tồn kho',
          icon: <AritoIcon icon={152} />,
          href: '/ton-kho/bao-cao-ton-kho/bao-cao-ton-kho'
        },
        {
          title: 'Thẻ kho/ Sổ chi tiết vật tư',
          icon: <AritoIcon icon={426} />,
          href: '/ton-kho/bao-cao-ton-kho/the-kho-so-chi-tiet-vat-tu'
        }
      ],
      group: 2
    },
    {
      title: 'Tổng hợp nhập xuất tồn',
      icon: <AritoIcon icon={132} />,
      items: [
        {
          title: 'Tổng hợp nhập xuất tồn theo kho',
          icon: <AritoIcon icon={133} />,
          href: '/ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-kho'
        },
        {
          title: 'Tổng hợp nhập xuất tồn theo giao dịch',
          icon: <AritoIcon icon={133} />,
          href: '/ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-giao-dich'
        },
        {
          title: 'Tổng hợp nhập xuất tồn theo đơn vị tính',
          icon: <AritoIcon icon={134} />,
          href: '/ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-don-vi-tinh'
        },
        {
          title: 'Tổng hợp nhập xuất tồn theo đối tượng & quy cách',
          icon: <AritoIcon icon={134} />,
          href: '/ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-doi-tuong-va-quy-cach'
        }
      ],
      group: 2
    },
    {
      title: 'Tình hình nhập/xuất kho',
      icon: <AritoIcon icon={142} />,
      items: [
        {
          title: 'Báo cáo tình hình xuất điều chuyển kho trung tâm',
          icon: <AritoIcon icon={137} />,
          href: '/ton-kho/tinh-hinh-nhap-xuat-kho/bao-cao-tinh-hinh-xuat-dieu-chuyen-kho-trung-tam'
        },
        {
          title: 'Bảng kê nhập/xuất kho',
          icon: <AritoIcon icon={137} />,
          href: '/ton-kho/tinh-hinh-nhap-xuat-kho/bang-ke-nhap-xuat-kho'
        },
        {
          title: 'Báo cáo tình hình nhập/xuất điều chuyển',
          icon: <AritoIcon icon={136} />,
          href: '/ton-kho/tinh-hinh-nhap-xuat-kho/bao-cao-tinh-hinh-nhap-xuat-dieu-chuyen'
        }
      ],
      group: 2
    },
    {
      title: 'Báo cáo kho khác',
      icon: <AritoIcon icon={575} />,
      items: [
        {
          title: 'Báo động tồn kho vật tư',
          icon: <AritoIcon icon={147} />,
          href: '/ton-kho/bao-cao-kho-khac/bao-dong-ton-kho-vat-tu'
        },
        {
          title: 'Bảng giá trung bình tháng',
          icon: <AritoIcon icon={255} />,
          href: '/ton-kho/bao-cao-kho-khac/bang-gia-trung-binh-thang'
        }
      ],
      group: 2
    }
  ]
};
